import Pagination from '../vc-pagination/locale/ca_ES'
import DatePicker from '../date-picker/locale/ca_ES'
import TimePicker from '../time-picker/locale/ca_ES'
import Calendar from '../calendar/locale/ca_ES'

export default {
  locale: 'ca',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  Table: {
    filterTitle: 'Filtrar Menu',
    filterConfirm: 'OK',
    filterReset: 'Restablir',
    emptyText: 'Sense dades',
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Cancel·lar',
    justOkText: 'OK',
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Cancel·lar',
  },
  Transfer: {
    notFoundContent: 'No trobat',
    searchPlaceholder: 'Cercar aquí',
    itemUnit: 'item',
    itemsUnit: 'items',
  },
  Select: {
    notFoundContent: 'No trobat',
  },
}



// WEBPACK FOOTER //
// ./components/locale-provider/ca_ES.js